/***************/
/**  IMPORTS  **/
/***************/
import { useState, useEffect } from "react";
import { Form, 
         Row, 
         Col 
} from "react-bootstrap";
import toast from 'react-hot-toast';
import Cookies from "universal-cookie";
import { RiCloseLine } from "react-icons/ri";
import { orbit } from 'ldrs';

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';
import { post, del } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { DarkBG,
         Centered,
         TheModal,
         ModalHeader,
         Heading,
         ModalContent,
         CloseButton,
         SubmitButton,
         NotesContainer, 
         Tab 
} from '../styles/ModalStyles';
import location_pin from '../assets/location_pin.svg';
import { useAuth } from '../utils/AuthContext';
import { useAddresses } from "../utils/LocationsContext";

/**
 * This component is responsible for creating a location details modal
 * @param { JSON Object } props 
 * @param { ObjectId } id 
 * @param { ObjectId } theID
 * @param { Function } setTheID
 * @param { Function} setSearchClicked
 * @param { Function } setModalOpen
 * @param { Function } setModalChange     
 * @returns A Location Details Modal
 */
const Modal = ({props, id, theID, setTheID, setSearchClicked, setModalOpen, modalOpen, modalChange, setModalChange, setAccountData, onUpdate}) => {

    const businessName = props.businessName;
    const status = props.status;
    const address = props.address;
    const lastMod = props.lastModified;
    const notes = props.notes;
    const modBy = props.modifiedBy;
    const [active, setActive] = useState("Details");
    const [statusChange, setStatusChange] = useState(props.status);
    const [businessNameChange, setBusinessNameChange] = useState(props.businessName);
    const [notesChange, setNotesChange] = useState(props.notes);
    const [loading, setLoading] = useState(false);
    const { userData, getUserDetails } = useAuth(); 
    /**  HANDLES GETTING ALL LOCATION DATA  **/
    const { addresses } = useAddresses();

    Amplify.configure(amplifyconfig);

    const cookies = new Cookies();
    const token = cookies.get("TOKEN");
    const email = localStorage.getItem("EMAIL");

    orbit.register();

    function debounceLeading(func, delay) {
        let inCooldown = false;

        return async (...args) => {
            if (inCooldown) return;

            inCooldown = true;
            try {
                await func(...args);
            } finally {
                setTimeout(() => {
                    inCooldown = false;
                }, delay);
            }
        };
    }

    /**  HANDLES MANUAL UPDATE SUBMIT  **/
    const handleSubmit = debounceLeading(async (e) => {
        e.preventDefault();

        setLoading(true);

        // Create a POST request for the manual update
        try {
            const update = post({
                apiName: 'LocationAPI',
                path: '/location/manual-update',
                options: {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: {
                        address,
                        statusChange,
                        status: props.status,
                        businessNameChange,
                        businessName: props.businessName,
                        notesChange,
                        theID,
                        email,
                    }
                }
            })

            const { body } = await update.response;
            const res = await body.json();
            console.log('Manual Update POST call succeeded', res);
            setModalChange(true);

            await addresses.refetch();
            // if(notesChange === "" || notesChange === null || notesChange === undefined){
            //     if(notesChange !== notes){ // only if notes have changed
            //         await deleteCommentAlert();
            //     }
            // } else {
            //     if(notesChange !== notes){ // only if notes have changed
            //         await addCommentForUser();
            //     }
            // }
            // Send success notification for manual update
            toast.success(`You have successfully updated the address: ${address}`, {
                position: 'top-center',
                duration: 5000,
            });
        } catch(e){
            setLoading(false);
            console.log('Manual Update POST call failed: ', e);
        } finally {
            setLoading(false);
            setModalChange(false);
        }
    }, 1500);

    /**  HANDLES ADDING COMMENTS TO USERS SO PLUS SIGN CAN BE ADDED  **/
    // const addCommentForUser = async () => {
    //     /**
    //      * Send comment notification to each user
    //      */
    //     if(notesChange !== notes){
    //         try {
    //             const update = post({
    //                 apiName: 'UserAPI',
    //                 path: '/user/comments-update',
    //                 options: {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                     },
    //                     body: {
    //                         id: theID,
    //                         email
    //                     }
    //                 }
    //             })
    
    //             const { body } = await update.response;
    //             const res = await body.json();
    //             console.log('Comments Update POST call succeeded', res);
    //         } catch(e) {
    //             console.log('Comments Update POST call failed: ', e);
    //         }
    //     }
    // }

    /**  HANDLES DELETING A COMMENT  **/
    // async function deleteCommentAlert(){
    //     try{
    //         // Create a DELETE request with query parameters
    //         const deleteCommentAlert = del({
    //             apiName: 'UserAPI',
    //             path: `/user/delete-comment-alert?id=${theID}`,
    //             options: {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`
    //                 }
    //             }
    //         });

    //         const { body } = await deleteCommentAlert.response;
    //         const res = await body.json();
    //         console.log('Deleting comment alert DELETE call succeeded', res);
    //     } catch (e) {
    //         console.log('Deleting notification DELETE call failed: ', e);
    //     }
    // }

    /**  HANDLES MAKING SCROLLING STOP WHEN A MODAL IS OPEN  **/
    useEffect(() => {
        if(modalOpen) {
            document.body.style.overflow = 'hidden';
        }
    }, [modalOpen])

    /**  HANDLES CHANGING BUSINESS INFO WHEN DATA CHANGES  **/
    useEffect(() => {
        setBusinessNameChange(props.businessName);
        setStatusChange(props.status);
        setNotesChange(props.notes);
    }, [props.businessName, props.status, props.notes]);
    
    /**  HANDLES RESETTING ACCOUNT DATA  **/
    useEffect(() => {
        resetAccountData();
    }, [modalChange]);

    async function resetAccountData(){
        const res = await getUserDetails();
        setAccountData(res);
    }

    return (
        <>
        {id === theID ? (
            <>
                <DarkBG onClick={() => {
                                        setModalOpen(false);
                                        document.body.style.overflow = 'unset';
                                        setSearchClicked(false);
                                        setTheID("");
                                        }} />
                <Centered>
                    <TheModal>
                            <ModalHeader>
                                <Heading>Business Details</Heading>
                            </ModalHeader>
                        <CloseButton onClick={() => {
                                        setModalOpen(false)
                                        document.body.style.overflow = 'unset'
                                        setSearchClicked(false);
                                        setTheID("");
                                        }}>
                        <RiCloseLine/>
                        </CloseButton>
                        <ModalContent>
                            <div style={{display:"flex", justifyContent:"center"}}><img src={location_pin} style={{height: "20px", width: "18px"}}/>&nbsp;&nbsp;{address}</div>
                            <div style={{paddingBottom: "35px", display:"flex", justifyContent:"center"}}>
                                <Tab
                                    $active={active === "Details"}
                                    onClick={() => setActive("Details")}>Details</Tab>
                                <Tab
                                    $active={active === "Edit"}
                                    onClick={() => setActive("Edit")}>Edit</Tab>
                            </div>
                            {active === "Details" ? (
                                <>
                                    <Row>
                                        <Col>Business Name:</Col>
                                        <Col>{businessNameChange}</Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col>Status:</Col>
                                        <Col>{statusChange}</Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col>Modified By:</Col>
                                        <Col>{modBy}</Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col>Last Modified:</Col>
                                        <Col>{lastMod}</Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col>Address:</Col>
                                        <Col>{address}</Col>
                                    </Row>
                                    <Row style={{paddingBottom:"10px"}}>
                                        <Col>Notes:</Col>
                                    </Row>
                                    <Row>
                                        <Col><NotesContainer>{notesChange}</NotesContainer></Col>
                                    </Row>
                                </>
                            ) : (
                                <>
                                <Form>
                                    {/* Business Name Change */}
                                    <Form.Group controlId="formBusinessName">
                                        <Form.Label>Business Name</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        name="businessName" 
                                        value={businessNameChange}
                                        onChange={(e) => setBusinessNameChange(e.target.value)}
                                        placeholder="Type New Business Name" />
                                    </Form.Group>
                                    <br />

                                    {/* Status Change */}
                                    <Form.Group controlId="formStatus">
                                        <Form.Label>Status</Form.Label>
                                        <Form.Select 
                                        type="dropdown" 
                                        name="status" 
                                        value={statusChange}
                                        onChange={(e) => setStatusChange(e.target.value)}>
                                            <option value="Available">Available</option>
                                            <option value="Unavailable">Unavailable</option>
                                            <option value="Temporarily Closed">Temporarily Closed</option>
                                            {/* <option value="Building For Sale">Building For Sale</option> */}
                                        </Form.Select>
                                    </Form.Group>
                                    <br />

                                    {/* Notes Change */}
                                    <Form.Group controlId="formNotes">
                                        <Form.Label>Notes</Form.Label>
                                        <Form.Control
                                        as="textarea"
                                        type="text" 
                                        name="notes" 
                                        value={notesChange}
                                        onChange={(e) => setNotesChange(e.target.value)}
                                        placeholder="Type new notes" 
                                        style={{height:"100px", verticalAlign:"top"}}/>
                                    </Form.Group>
                                    <br />

                                    {/* submit button */}
                                    <div className='button-style'>
                                        <SubmitButton 
                                            variant="primary" 
                                            type="submit"
                                            onClick={(e) => handleSubmit(e)}>
                                            { loading ? 
                                                <l-orbit 
                                                    size="30"
                                                    speed="1.5"
                                                    color="#FFFFFF">
                                                </l-orbit> : "Make Changes" }
                                        </SubmitButton>
                                    </div>
                                </Form>
                                </>
                            )}
                        </ModalContent>
                    </TheModal>
                </Centered>

            </>
        ) : (
            <></>
        )}
        </>
    )
}

export default Modal;
